import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Icons from '../../../../../common/widgets/Icons';
import { rewriteImageUrl } from '../../../helpers';
import { ContestModel } from '../../../models/Contest';
import { getLabelResource } from './utils';

export const ContestBanner = (props: { contest: ContestModel }) => {
  const { contest } = props;
  const { t: translate } = useTranslation();

  return (
    <div className="contest-banner">
      <div className="contest-banner-image">
        <img
          src={rewriteImageUrl(contest.homepageBanner)}
          alt={contest.title}
        />
      </div>
      <div className="contest-banner-copy">
        <div className="contest-banner-title">{contest.title}</div>
        <div
          className="contest-banner-description"
          dangerouslySetInnerHTML={{
            __html: contest.shortDescription ?? '',
          }}
        ></div>
        <div className="contest-banner-action">
          <Link to={`/contests/${contest.contestId}`} className="btn-link">
            <span className="btn-icon">
              <Icons.ArrowButton />
            </span>
            <span className="btn-text">
              {translate(getLabelResource(contest.status))}
            </span>
          </Link>
        </div>
      </div>
    </div>
  );
};
